/**
 * Rozbiór treści maila na to, co ktoś NAPISAŁ, i na cytowaną historię.
 *
 * Skrzynka ARON-a dostaje zwykłe firmowe maile: pod właściwą wiadomością wisi
 * cała poprzednia korespondencja, stopki i artefakty MIME. Wrzucone na ekran
 * jednym blokiem `pre-wrap` (tak było) topią polecenie w ścianie tekstu.
 */

/** Pierwsza linia, od której zaczyna się cytat/poprzednia korespondencja. */
const QUOTE_MARKERS: RegExp[] = [
  /^_{5,}\s*$/, // separator Outlooka
  /^-{2,}\s*(Original Message|Wiadomość oryginalna|Forwarded message)\s*-{2,}/i,
  /^(Od|From|Wysłane|Sent|Do|To|Temat|Subject)\s*:\s.+/i,
  /^W dniu .*napisał/i,
  /^On .*wrote:\s*$/i,
  /^>/,
];

/** Odwołania do obrazków osadzonych w HTML — dla człowieka to śmieć. */
const CID_RE = /\[cid:[^\]]+\]/g;

export interface MailBodyParts {
  /** Właściwa treść wiadomości. */
  body: string;
  /** Cytowana historia (pusta, gdy jej nie ma) — chowana pod przyciskiem. */
  quoted: string;
}

export function splitMailBody(raw: string): MailBodyParts {
  const clean = (raw || "").replace(CID_RE, "").replace(/\r\n/g, "\n");
  const lines = clean.split("\n");
  const cut = lines.findIndex((l) => QUOTE_MARKERS.some((re) => re.test(l.trim())));
  if (cut === -1) return { body: trimBlank(clean), quoted: "" };

  const body = trimBlank(lines.slice(0, cut).join("\n"));
  const quoted = trimBlank(lines.slice(cut).join("\n"));
  // Mail będący wyłącznie cytatem (np. samo "FW:") — lepiej pokazać wszystko,
  // niż zostawić pustą kartkę z guzikiem „pokaż historię".
  return body ? { body, quoted } : { body: quoted, quoted: "" };
}

function trimBlank(s: string): string {
  return s.replace(/^\s*\n+/, "").replace(/\s+$/, "");
}
